import React from 'react';
import { Image } from 'react-bootstrap';
import logo from '../../assets/images/parrotfy-logo.svg';
import twistLogo from '../../assets/images/twist-logo.svg';

function OnboardingHeader({ componentSubtitle, isTwistGo, isIframeMode }) {
  return (
    <div className="text-center">
      {!isIframeMode && (
        <>
          <Image
            src={isTwistGo ? twistLogo : logo}
            alt="Logo"
            className="img-fluid mb-3"
            style={{ maxWidth: '150px' }}
          />
          {componentSubtitle}
        </>
      )}
    </div>
  );
}

export default OnboardingHeader;
